import {FormControl, FormGroup} from '@angular/forms';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
    ApiError,
    ApiResponse,
    HttpStatusCodesEnum,
    IndividualsService,
    PurposeOfTradingModel,
    IndividualExtendedModel,
    IndividualPurposeOfTradingInputModel,
} from '@spa/api';

import {InArrayValidator} from '@spa/validators';

import {Helper, SelectControl} from '../../../../shared/classes';

import {PurposeOfTradingControl, PurposeOfTradingSelector} from '../../../../../assets/descriptors';

export class PurposeOfTradingForm {
    private readonly individual: IndividualExtendedModel;
    private readonly purposeOfTradingList: PurposeOfTradingModel[];
    private readonly individualService: IndividualsService;

    public formGroup: FormGroup;
    public control: SelectControl;

    constructor(
        individual: IndividualExtendedModel,
        purposeOfTradingList: PurposeOfTradingModel[],
        individualService: IndividualsService
    ) {
        this.control = null;

        this.individual = individual;
        this.purposeOfTradingList = purposeOfTradingList;
        this.individualService = individualService;
    }

    private updatePurposeOfTrading(selectedPurposeOfTrading: number): Observable<ApiResponse<ApiError[] | boolean>> {
        const clonedPurposeOfTrading = this.individual.purposeOfTradingId;

        const model = new IndividualPurposeOfTradingInputModel(
            this.individual.id,
            selectedPurposeOfTrading
        );

        return this.individualService.updatePurposeOfTrading(model).pipe(
            map(this.updatePurposeOfTradingMap.bind(this, clonedPurposeOfTrading, selectedPurposeOfTrading))
        );

    }

    private updatePurposeOfTradingMap(
        clonedPurposeOfTrading: number,
        selectedPurposeOfTrading: number,
        response: ApiResponse<ApiError[] | null>
    ): ApiResponse<ApiError[] | boolean> {
        if (response.status !== HttpStatusCodesEnum.Ok) {
            this.individual.purposeOfTradingId = clonedPurposeOfTrading;

            return Helper.errorsHelper().createErrorResponse<null>(response);
        }

        this.individual.purposeOfTradingId = selectedPurposeOfTrading;

        return Helper.createSuccessResponse<boolean>(true);
    }

    initForm() {
        this.formGroup = new FormGroup({});
        this.control = PurposeOfTradingControl();

        this.control.name = PurposeOfTradingSelector;

        if (this.individual && this.individual.purposeOfTradingId) {
            this.control.value = this.individual.purposeOfTradingId;
        }

        this.control.options =
            this.purposeOfTradingList.map((listItem: PurposeOfTradingModel) => {
                return {
                    label: listItem.name,
                    value: listItem.id
                };
            });

        const purposeOfTradingIds =
            this.purposeOfTradingList.map((listItem: PurposeOfTradingModel) => listItem.id);

        this.control.extendValidators(InArrayValidator(purposeOfTradingIds));

        this.formGroup.addControl(this.control.name, new FormControl(this.control.value, this.control.validators));
    }

    validateForm(messageFunction: (controlLabel?: string) => { [key: string]: string; }): boolean {
        const controls = this.formGroup.controls;

        if (controls[PurposeOfTradingSelector].invalid) {
            this.control.errors = Object
                .keys(controls[PurposeOfTradingSelector].errors)
                .map((errorKey: string) => {
                    return messageFunction(this.control.placeholder)[errorKey];
                });

            return false;
        }

        return true;
    }

    createRequest(): Observable<ApiResponse<ApiError[] | boolean>> | null {
        const selectedPurposeOfTrading = this.formGroup.controls[PurposeOfTradingSelector].value as number;

        if (this.individual.purposeOfTradingId !== selectedPurposeOfTrading) {
            return this.updatePurposeOfTrading(selectedPurposeOfTrading);
        }

        return null;
    }
}
